import _objectWithoutPropertiesLoose from "@babel/runtime/helpers/esm/objectWithoutPropertiesLoose";
import { useContext, useEffect } from 'react';
import WizardContext from './WizardContext';

function Step(_ref) {
  var children = _ref.children,
      name = _ref.name,
      valid = _ref.valid;

  var _useContext = useContext(WizardContext),
      addStep = _useContext.addStep,
      wizard = _objectWithoutPropertiesLoose(_useContext, ["addStep"]);

  useEffect(function () {
    return addStep({
      name: name,
      valid: valid
    });
  }, []);
  return children(wizard);
}

export default Step;